import React from 'react';
import Statistic from './statistic';
import { useTranslation } from 'react-i18next';

const AppDashboard = () => {
    const { t } = useTranslation();
    
    return (
        <div className='space-y-5'>
            <h1 className='flex h-10 items-center justify-start text-xl md:text-2xl font-semibold'>{t('menu.dashboard')}</h1>
            <Statistic t={t} />
        </div>
    );
};

export default AppDashboard;
